import { publishEvent } from '@salesforce/scv-connector-base';
import type { UserLogoutEventPublisher } from '@usecases/user-logout.usecase';

export class UserLogoutPublisher implements UserLogoutEventPublisher {
  async removeNumberDetails(): Promise<void> {
    const numbers = {};
    publishEvent({
      eventType: 'MESSAGE',
      payload: {
        type: 'SCV.NUMBER_LIST',
        data: {
          numbers,
        },
      },
      registerLog: false,
    });
  }
}
